import React from 'react';

const Select = ({ value, text, list, onChange }) => {
  const getStatusOptions = () => {
    return list.map((status) => (
      <option key={status.id} value={status.id}>
        {status.name}
      </option>
    ));
  };

  return (
    <div>
      <span>{text}: </span>
      <select value={value} id="select" onChange={onChange}>
        <option value="-1">All</option>
        {getStatusOptions()}
      </select>
    </div>
  );
};

const styles = {};
export default Select;
